import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Consumers';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of consumer',
	breadcrumbs: [
		{
			title: title,
			link: '/clients/consumers',
		},
	],
};

export default function EditConsumer() {
	const [loader, setLoader] = useState(false),
		[data, setData] = useState({}),
		[clients, setClients] = useState([]),
		[errors, setErrors] = useState({}),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		{ id } = useParams(),
		[client, setClient] = useState();

	async function onGet() {
		setLoading(true);
		let res = await resources.consumer
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			setData(res.data);
		} else if (res.status === 403) {
			setFail(true);
		}

		let cli = await resources.customer
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cli.status === 200) {
			let a = [];
			cli.data.docs.forEach((el) => {
				if (res.data.client === el.id) {
					setClient({
						value: el.id,
						label: el.name,
					});
				}
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setClients(a);
		}
		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, [id]);
	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (object.password.length === 0) {
			delete object.password;
			delete object.password_confirmation;
		}
		if (client) object.client = client.value;
		setLoader(true);
		setErrors({});
		let res = await resources.consumer
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/clients/consumers');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Client
									</label>
									<Select
										onChange={(e) => setClient(e)}
										options={clients}
										isSearchable
										isClearable
										value={client}
										className={
											errors['client']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['client'] && (
										<div className="invalid-feedback">
											{errors['client']}
										</div>
									)}
								</div>

								<Field
									name="surname"
									error={errors['surname']}
									className="mb-3"
									required
									defaultValue={data.surname}
								>
									consumer name
								</Field>
								{/* <div className="mb-3">
												<label
													htmlFor="exampleInputEmail1"
													className="form-label"
												>
													Card number
												</label>
												<Select
													name="card"
													options={filterCard()}
													isSearchable
													isMulti
													isClearable
													className={
														errors['card']
															? ' is-invalid'
															: ''
													}
												/>
												{errors['card'] && (
													<div className="invalid-feedback">
														{errors['card']}
													</div>
												)}
											</div> */}

								<Field
									name="email"
									type="email"
									error={errors['email']}
									className="mb-3"
									required
									defaultValue={data.email}
								>
									Email
								</Field>

								<Field
									name="contacts"
									error={errors['contacts']}
									className="mb-3"
									required
									defaultValue={data.contacts}
								>
									Contact
								</Field>

								<Field
									name="password"
									type="password"
									error={errors['password']}
									className="mb-3"
								>
									Password
								</Field>

								<Field
									name="password_confirmation"
									type="password"
									error={errors['password_confirmation']}
									className="mb-3"
								>
									password confirmation
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
									defaultValue={data.description}
								>
									Note
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary "
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
